import { Typography } from '@mui/material';
import Button from '../foundation/Button/Button';
import DialogWithHeader from '../foundation/DialogWithHeader';
import {
    GoogleAuthNoticeActions,
    GoogleAuthNoticeContent,
    GoogleAuthNoticeIllustration,
} from './GoogleAuthNoticeDialog.styles';

export type GoogleUnverifiedAccountDialogProps = {
    open: boolean
    onClose: () => void
    onLoginWithPassword: () => void
    onResetPassword: () => void
};

export default function GoogleUnverifiedAccountDialog(
    props: GoogleUnverifiedAccountDialogProps,
) {
    return <DialogWithHeader
        open={props.open}
        onClose={props.onClose}
        title="החשבון כבר קיים"
    >
        <GoogleAuthNoticeContent>
            <GoogleAuthNoticeIllustration
                src="/images/registration-required.png"
                alt="איור כרטיס משתמש"
            />
            <Typography variant="h5" fontWeight="bold">יש להתחבר לחשבון הקיים</Typography>
            <Typography variant="body1" color="text.secondary">
                כתובת המייל הזו כבר משויכת לחשבון שנוצר באמצעות מייל וסיסמה. מטעמי אבטחה,
                לא ניתן להתחבר אליו באמצעות Google לפני אימות כתובת המייל. יש להתחבר לחשבון
                הקיים ולאמת את המייל בעמוד הפרופיל; לאחר מכן יהיה ניתן להתחבר גם באמצעות Google.
            </Typography>
            <GoogleAuthNoticeActions>
                <Button fullWidth size="large" onClick={props.onLoginWithPassword}>
                    להתחברות עם מייל וסיסמה
                </Button>
                <Button fullWidth variant="text" onClick={props.onResetPassword}>
                    שכחת את הסיסמה? לשחזור סיסמה
                </Button>
            </GoogleAuthNoticeActions>
        </GoogleAuthNoticeContent>
    </DialogWithHeader>;
}
